import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Accordion/sgds-accordion";
import { register } from "../../utils/ce-registry";

register("sgds-accordion", Component);

export default createComponent({
  react: React,
  tagName: "sgds-accordion",
  elementClass: Component,
  events: {}
});
